import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import { usePrevious } from '@ui/src';
import useFintracReport from '../hooks/use-report';
import ReportTableContent from './report-table';
import { clearReports } from '../store/slices/list';

import cn from '../styles.module.css';

const FintracReport = ({ type }: { type: 'eftr' | 'lvctr' }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const { activePermissions, currencies } = useAppSelector(
    (state) => state.root,
  );

  const prevType = usePrevious(type);

  const {
    transactions,
    transactionsPagination,
    reports,
    reportsPagination,
    selectedTransactions,
    reportsErrorsList,
  } = useAppSelector((state) => state.fintrac.list);

  const dispatch = useAppDispatch();

  const {
    statusFilter,
    setStatusFilter,
    formattedData,
    onExpand,
    cancelReportVisible,
    setCancelReportVisible,
    submitReportVisible,
    setSubmitReportVisible,
    selectedReportAmount,
    addTransactionsSidepanelVisible,
    setAddTransactionsSidepanelVisible,
    isLoading,
    isFetching,
    setPage,
    onSort,
    errorList,
    sort,
    filtersComponent,
    handleSubmit,
    filters,
    onFilter,
    selectedReportTransferDate,
    setSelectedReportTransferDate,
    selectedReportId,
    deletePopupVisible,
    setDeletePopupVisible,
    setDeleteReportId,
    deleteError,
    deleteInProgress,
    onDeleteReport,
    onSubmitReport,
    submitInProgress,
    onCancelReport,
    cancelInProgress,
    setDeleteError,
  } = useFintracReport({
    reports,
    transactions,
    transactionsPagination,
    selectedTransactions,
    activePermissions,
    type,
    currencies,
  });

  useEffect(() => {
    if (type && prevType && type !== prevType) {
      dispatch(clearReports());
    }
  }, [type, prevType]);

  useEffect(() => {
    dispatch(clearReports());
  }, []);

  return (
    <div className={cn.fintracReportWrapper} ref={scrollRef}>
      <ReportTableContent
        formattedData={formattedData}
        onExpand={onExpand}
        pagination={reportsPagination}
        type={type}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        cancelReportVisible={cancelReportVisible}
        setCancelReportVisible={setCancelReportVisible}
        submitReportVisible={submitReportVisible}
        setSubmitReportVisible={setSubmitReportVisible}
        selectedReportAmount={selectedReportAmount}
        addTransactionsSidepanelVisible={addTransactionsSidepanelVisible}
        setAddTransactionsSidepanelVisible={setAddTransactionsSidepanelVisible}
        selectedReportTransferDate={selectedReportTransferDate}
        setSelectedReportTransferDate={setSelectedReportTransferDate}
        activePermissions={activePermissions}
        isLoading={isLoading}
        isFetching={isFetching}
        setPage={setPage}
        onSort={onSort}
        errorList={reportsErrorsList || errorList}
        sort={sort}
        filtersComponent={filtersComponent}
        handleSubmit={handleSubmit}
        filters={filters}
        onFilter={onFilter}
        selectedReportId={selectedReportId}
        deletePopupVisible={deletePopupVisible}
        setDeletePopupVisible={setDeletePopupVisible}
        setDeleteReportId={setDeleteReportId}
        deleteError={deleteError}
        deleteInProgress={deleteInProgress}
        onDeleteReport={onDeleteReport}
        onSubmitReport={onSubmitReport}
        submitInProgress={submitInProgress}
        onCancelReport={onCancelReport}
        cancelInProgress={cancelInProgress}
        setDeleteError={setDeleteError}
      />
      <Outlet />
    </div>
  );
};

export default FintracReport;
